import router from './router/index'

const whiteList = ['/']

router.beforeEach((to, from, next) => {
  next()
})



// WEBPACK FOOTER //
// ./src/permission.js